import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseBackendUrl } from '../utils/api-utils';
import { loginSuccess, loginFailure, registerFailure, registerSuccess, setUserLoading, resetSuccess, resetFailure } from "../redux/userSlice";

export const login = createAsyncThunk('user/login', async (arg, {dispatch}) => {
    dispatch(setUserLoading())
    try {
        const response = await fetch(`${baseBackendUrl}/auth/login`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(arg)
        })
        
        const res = await response.json();
        if (response.ok) {
            dispatch(loginSuccess({user: res.user, token: res.token}));
            arg.navigate("/");
        } else {
            throw new Error(res)
        }
    } catch (error) {
        console.log(error.message)
        dispatch(loginFailure(error.message))
    }
})

export const register = createAsyncThunk('user/register', async (arg, {dispatch}) => {
    dispatch(setUserLoading())
    try {
        const response = await fetch(`${baseBackendUrl}/auth/register`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                name: arg.name,
                username: arg.username,
                email: arg.email,
                password: arg.password,
            })
        })
        
        const res = await response.json();
        console.log(res)
        if (response.ok) {
            dispatch(registerSuccess({user: res.newUser, token: res.token}));
            arg.navigate("/")
        } else {
            throw new Error(res)
        }
    } catch (error) {
        console.log(error.message)
        dispatch(registerFailure(error.message))
    }
})

export const resetPassword = createAsyncThunk('user/reset', async (arg, {dispatch}) => {
    dispatch(setUserLoading())
    try {
        const response = await fetch(`${baseBackendUrl}/auth/reset`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                email: arg.email,
                newPassword: arg.newPassword,
            })
        })
        
        const res = await response.json();
        console.log(res)
        if (response.ok) {
            dispatch(resetSuccess({user: res.user, token: res.token}));
            arg.navigate("/")
        } else {
            throw new Error(res)
        }
    } catch (error) {
        console.log(error.message)
        dispatch(resetFailure(error.message))
    }
})